const onHold = {
  holdReasons(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/hold`;
  },
  onHold() {
    return `/homeowner/cases/hold/on`;
  },
  offHold() {
    return `/homeowner/cases/hold/off`;
  },
};

export default onHold;